import { r } from './useApi';
import { keeper } from './utils';

export const validateTemplateVersion = async (id) => {
    const res = await r({
        endpoint: `${keeper('apiUrl')}/v2/templateVersion/${id}/pdf-accessibility`,
        sessionToken: keeper('sessionToken'),
        method: 'get',
    });
    return res;
};

export const useValidation = () => {
    return {
        validateTemplateVersion,
    };
};

export default useValidation;
